"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subbanner = void 0;
const react_1 = __importDefault(require("react"));
require("./subbanner.css");
;
/**
 * Main component.
 * @name Subbanner
 * @param {SubbannerProps}
 * @returns {<Subbanner />}
*/
const Subbanner = ({ desktopImage, mobileImage, textColor = '#213450', maxSubbannerHeight = 300, maxSubbannerContentWidth = 50, title, subtitle, buttonLinks }) => {
    const shouldShowSubbannerContent = Boolean(title || subtitle || (buttonLinks === null || buttonLinks === void 0 ? void 0 : buttonLinks.length));
    const checkURL = (url) => {
        //Check if url has url()
        if (url.indexOf('url(') === -1) {
            return `url('${url}')`;
        }
        return url;
    };
    return (react_1.default.createElement("div", { "data-testid": "subbanner-element", className: "subbanner-container", style: {
            color: textColor,
            maxHeight: maxSubbannerHeight,
        } },
        react_1.default.createElement("img", { className: "subbanner-desktop-image", src: desktopImage }),
        react_1.default.createElement("img", { className: "subbanner-mobile-image", src: mobileImage }),
        shouldShowSubbannerContent && (react_1.default.createElement("div", { className: "subbanner-content", style: {
                maxWidth: `${maxSubbannerContentWidth}%`
            } },
            react_1.default.createElement("h2", { className: "subbanner-content-title" }, title),
            react_1.default.createElement("p", { className: "subbanner-content-subtitle" }, subtitle),
            (buttonLinks === null || buttonLinks === void 0 ? void 0 : buttonLinks.length) && (react_1.default.createElement("div", { className: "subbanner-content-buttonlinks-container" }, buttonLinks.map((buttonLink, i) => (react_1.default.createElement("a", { key: i, className: "subbanner-content-buttonlink", href: buttonLink.link, target: '_blank' },
                react_1.default.createElement("img", { src: buttonLink.imageUrl }))))))))));
};
exports.Subbanner = Subbanner;
//# sourceMappingURL=subbanner.js.map